export const dashInvoices = {
  invoices: {
    title: "Facturas pendientes de envío",
    subtitle: "Aquí verás las solicitudes pendientes para emisión de factura.",
    loading: "Cargando…",
    empty: "No hay facturas pendientes de envío.",
    guestFallback: "Huésped",
    manualBadge: "Manual",
    manualBadgeTitle: "No se genera automáticamente: la emites tú manualmente",
    manualCheckoutTitle: "No se genera automáticamente: emítela tú manualmente",
    linkSentTitle: "Enlace enviado al huésped",
    linkPendingTitle: "El enlace se enviará el día del check-out",
    manualIssue: "Emisión manual",
    sendLinkTitle: "Enviar al huésped el enlace para completar sus datos de factura",
    resend: "Reenviar",
    sendLink: "Enviar link",
    closeRequestTitle: "Cerrar esta solicitud (la emites tú manualmente)",
    close: "Cerrar",
    cancelAutoTitle: "Anular el envío automático para enviarla manualmente por otro medio",
    cancel: "Anular",
    viewAll: "Ver todas las facturas",
    confirmCancel: {
      title: "¿Anular el envío automático?",
      html: "No se enviará el enlace de factura al huésped.<br>Podrás enviársela manualmente por otro medio.",
      confirm: "Sí, anular",
      cancel: "No",
    },
    confirmSend: {
      title: "¿Enviar el enlace de factura?",
      html: "Se enviará al huésped por WhatsApp el enlace para completar sus datos fiscales.<br>La factura la emites tú manualmente.",
      confirm: "Sí, enviar",
      cancel: "No",
    },
    cancelError: {
      title: "No se pudo anular",
    },
    closeError: {
      title: "No se pudo cerrar",
    },
    sendError: {
      title: "No se pudo enviar",
    },
    sendSuccess: {
      title: "Enlace enviado",
      text: "El huésped ha recibido el enlace de factura.",
    },
    retry: "Inténtalo de nuevo.",
  },
  balances: {
    title: "Saldos pendientes",
    subtitle: "Reservas con importe por cobrar.",
    total: "Total",
    paid: "Pago procesado",
    loading: "Cargando…",
    empty: "No hay saldos pendientes.",
    emptySub: "Cuando una reserva tenga importe por cobrar, aparecerá aquí.",
    viewAll: "Ver todos los saldos",
  },
  balancesDrawer: {
    title: "Saldos pendientes",
    close: "Cerrar",
    from: "Desde",
    to: "Hasta",
    sort: "Ordenar",
    sortArrival: "Fecha de entrada",
    sortProximity: "Proximidad de llegada",
    searchPlaceholder: "Buscar alojamiento…",
    allAccommodations: "Todos los alojamientos",
    noResults: "Sin resultados",
    clear: "Limpiar",
    totalPending: "Total pendiente",
    ofTotal: "de {amount} {currency}",
    loading: "Cargando…",
    empty: "No hay reservas con saldo pendiente.",
    end: "No hay más.",
    tags: {
      ended: "Estancia finalizada",
      now: "En casa",
      today: "Llega hoy",
      tomorrow: "Llega mañana",
      dayAfter: "Llega pasado",
    },
  },
};
